import React from "react";
import { bool, func, string } from "prop-types";
import Button from "pages/_components/Button";
import ReactTagWithoutInput from "./ReactTagWithoutInput";

const FilterTags = ({ openSideBarFilters, optiondebin, isReceived, isRecurrent, isEmited, isScheduled }) => (
    <div className="tags-filter">
        <Button
            image="images/figma/icon/filter.svg"
            onClick={openSideBarFilters}
            label="global.filter"
            className="btn btn-link open-filters"
            block={false}
        />
        <ReactTagWithoutInput
            optiondebin={optiondebin}
            isReceived={isReceived}
            isRecurrent={isRecurrent}
            isEmited={isEmited}
            isScheduled={isScheduled}
        />
    </div>
);

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
    optiondebin: string.isRequired,
    isReceived: bool,
    isRecurrent: bool,
    isEmited: bool,
    isScheduled: bool,
};

FilterTags.defaultProps = {
    isReceived: false,
    isRecurrent: false,
    isEmited: false,
    isScheduled: false,
};

export default FilterTags;
